import React from 'react';
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Our Toolbox for Creating Custom Software Excellence</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Our developers use a proven combination of the latest and existing trusted technologies, with the following technology stack as the foundation:
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li>CSS</li>
                <li>Html</li>
                <li>JS</li>
                <li>Angular</li>
                <li>React</li>
                <li>Vue.js</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="BackEnd">
              <ul>
                <li>Python</li>
                <li>Node JS</li>
                <li>Microsoft.Net</li>
                <li>Go</li>
                <li>Java</li>
                <li>Php</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Databases">
              <ul>
                <li>ElasticSearch</li>
               <li>Redis</li>
               <li>PostgreSQL</li>
               <li> MySQL</li>
               <li> MongoDB</li>
               <li>Oracle</li>
               <li> Cassandra</li>
               <li> Hive</li>
               <li>HBase</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Platforms">
              <ul>
                <li>AWS</li>
                <li>Azure</li>
                <li>Google Cloud Platform</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li>Flutter</li>
                <li>Apache Cordova</li>
                <li>React Native</li>
                <li>Xamarin</li>
                <li>Ionic</li>
                <li> Sencha Ext JS</li>
                <li>JQuery Mobile</li>
                <li>Firebase</li>
                <li>SQLite</li>
                <li>CoreData</li>
                <li>Realm</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
